import {
  SIGNED_IN_MODE,
  SET_USER,
  SET_AUTHORIZED,
} from '../constants';

function authReducer(state, action) {
  const { type, data } = action;

  switch (type) {

    case SET_USER: {
      return { ...state, mode: SIGNED_IN_MODE, user: data };
    }

    case SET_AUTHORIZED: {
      return { ...state, isAuthorized: data }
    }

    default: {
      return state;
    }
  }
}

export default authReducer;
